import { ArticleType } from "@interfaces/legislation-news";
import { TitleProps } from "@store/title-store";

export const getNewsArticleBreadcrumbs = (type: ArticleType): TitleProps[] => {
  const title = [
    { title: "Главная", href: "/" },
    { title: "Новости", href: "/news/help" },
  ] as TitleProps[];

  const titles: Record<ArticleType, TitleProps> = {
    LEGISLATION: {
      title: "Новости законодательства",
      href: "/news/legislation",
    },
    PRACTICES: {
      title: "Судебная практика",
      href: "/news/practices",
    },
    HELP: {
      title: "Полезные материалы",
      href: "/news/help",
    },
    DEVELOPMENT: {
      title: "Скоро в Личном кабинете",
      href: "/news/development",
    },
    PROJECT: {
      title: "Новости проекта",
      href: "/news/project",
    },
  };
  title.push(titles[type]);

  return title;
};
